jQuery(function($) {

    const notActiveRegisterBlock = $('.nav-register').find('a').not('.active');

    notActiveRegisterBlock.on('click', function() {
        const navLogin = $('.nav-login').find('a');
        const cloneNavLogin = navLogin.clone();

        navLogin.addClass('active');
        $(this).removeClass('active');

        // Change the login title and params
        changeTabTitle(navLogin, $(this), true)
        
        // Change the current element title and params
        changeTabTitle($(this), cloneNavLogin, false);
    });
});

/**
 * Change the tab title and params
 * 
 * @param currentElement The actual element
 * @param otherElement The chancgable element
 * @param selected The aria selected or not
 */
function changeTabTitle(currentElement, otherElement, selected) {
    currentElement.find('h2').text(otherElement.find('h2').text());
    currentElement.attr('id', otherElement.attr('id'));
    currentElement.attr('href', otherElement.attr('href'));
    currentElement.attr('aria-controls', otherElement.attr('aria-controls'));
    currentElement.attr('aria-selected', selected);
}
